import { theme } from '@creatic/reactic-styles';

export const color = {
  white: '#ffffff',
  grey97: '#faf9f7',
  grey95: '#f1eee8',
  grey88: '#e6e1da',
  grey68: '#B7B1A7',
  grey61: '#a39d94',
  grey52: '#8c867d',
  grey41: '#6e6a64',
  grey21: '#3a3733',
  grey12: '#211f1d',
  violet98: '#f7f6fe',
  violet96: '#ededfc',
  violet64: '#5b5ceb',
  red84: '#f8c5c4',
  red47: '#c0453c',
};

export const metric = {
  launcherSize: '64px',
  offset: '24px',
  panelHeight: '600px',
  panelWidth: '400px',
};

export const shadow = {
  launcher: '0 10px 28px -8px rgba(33, 31, 29, 0.35)',
  panel: '0 24px 60px -16px rgba(33, 31, 29, 0.35)',
};

export const zIndex = {
  ...theme.zIndex,
  widget: 900,
};

const adaTheme = { ...theme, color, metric, shadow, zIndex };

export type TTheme = typeof adaTheme;

export const getTheme = (widgetZIndex?: number): TTheme => ({
  ...adaTheme,
  zIndex: { ...zIndex, widget: widgetZIndex ?? zIndex.widget },
});

export default adaTheme;
